export default "__VITE_ASSET__Br4Njd3F__"